import { resolverConfiguracaoDePacientes, type ConfiguracaoDePacientes } from "@bookdental/schemas";
import { trpc } from "./trpc";

const PADRAO = resolverConfiguracaoDePacientes(null);

/** Configurações › Pacientes da organização ativa. Enquanto carrega, o padrão (o comportamento de
 *  antes): nunca trava um formulário esperando a configuração chegar. */
export function useConfiguracaoDePacientes(): ConfiguracaoDePacientes {
  return trpc.settings.getPacientes.useQuery(undefined, { staleTime: 5 * 60_000 }).data ?? PADRAO;
}
